import HubBuyTherapyModule from './HubBuyTherapyModule'

export default HubBuyTherapyModule
